import { IQueryMediator } from 'core-ts-types';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';
import { IValidator } from '../validation/contracts';

function endTimeDatasourceTransactionCommandDefinition(
  defineCommand: any,
  externalActionCommand: any,
  executeCommandInSerial: any,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
  QueryMediator: IQueryMediator
) {
  return defineCommand(
    'endTimeDatasourceTransactionCommand',
    function endTimeDatasourceTransactionCommand(deferred: any, validators: IValidator[]) {
      ngTimeOccurrenceDataSource.endTransaction(validators);
      executeCommandInSerial(externalActionCommand);
      QueryMediator.runQueries(ngTimeOccurrenceDataSource);
      deferred.resolve();
    }
  );
}

angular
  .module('ui-ng-calendar')
  .factory('endTimeDatasourceTransactionCommand', endTimeDatasourceTransactionCommandDefinition);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/end_time_datasource_transaction.ts